module.exports = __webpack_public_path__ + "img/福建联合石油化工.26727874.png";